"use client";
import{jsx as t}from"react/jsx-runtime";import r from"../../atoms/Text/Text.js";function e(e){return t(r,{...e})}export{e as default};
